/* The contents of this file are generated automatically during the build process of this component.
 * If you need to make changes on these styles, go to the .scss files of this repository.
 * Once you are done, run the "npm run build" script to update this file and commit your changes, including this file.
*/

import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
`<template>
<style>
/*CSS-START*/
:host {
  display: block;
}
/*CSS-END*/
</style>
</template>`;

styleElement.register('wdpr-wc-travel-agent-session-background-refresh-style');
